import React from "react";
import { TopicForm, TopicFormValues } from "pages/Topics/TopicForm/TopicForm";
import { TopicApi, topicsApi } from "api";
import { PaziaModal } from "components/molecules";
import { timeToMinutes } from "utils";
import { ModalPadding } from "../Modals/ModalPadding";
import { useToaster } from "utils";

interface CreateTopicModalProps {
  onCloseRequest: () => void;
  isOpen: boolean;
  onSuccess: (topic: TopicApi) => void;
}

export const CreateTopicModal = ({ onCloseRequest, isOpen, onSuccess }: CreateTopicModalProps) => {
  const { showError, showSuccess } = useToaster();

  const onSubmit = async (data: TopicFormValues) => {
    try {
      const { time, ...request } = data;

      const res = await topicsApi.create({ ...request, time: timeToMinutes(time) });
      onSuccess(res.data);
      showSuccess("Temat został dodany");
    } catch (e) {
      console.error(e);
      showError("Nie udało się dodać tematu");
    }
  };

  return (
    <PaziaModal id="craete-topic-modal" onCloseRequest={onCloseRequest} isOpen={isOpen} size="3xl">
      <ModalPadding>
        <div className="text-xl">
          <div className="font-medium text-slate-800 dark:text-slate-100 mb-2">Tworzenie nowego tematu</div>
        </div>

        <TopicForm onSubmit={onSubmit} />
      </ModalPadding>
    </PaziaModal>
  );
};
